import getDevice from './device'
export {    
    getDevice
}